import { TTaskFolder } from '../types'

// A task list's order is only the user's to change under the Manual sort. Any other sort derives the
// order from task fields, and done/trash folders have a fixed order of their own. Dragging a task
// elsewhere (a sidebar folder, the calendar) is a move, not a reorder, and stays allowed regardless.
export const canReorderTaskList = (sortId: string, folder?: Pick<TTaskFolder, 'is_done' | 'is_trash'>) =>
    sortId === 'manual' && !folder?.is_done && !folder?.is_trash
